import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isTokenValid()) {
    return true;
  }

  return auth.refreshSession().pipe(
    map((refreshed) =>
      refreshed
        ? true
        : router.createUrlTree(['/connexion'], { queryParams: { redirect: state.url } }),
    ),
    catchError(() =>
      of(router.createUrlTree(['/connexion'], { queryParams: { redirect: state.url } })),
    ),
  );
};

/** Empêche un utilisateur déjà connecté de revoir les écrans de connexion/inscription. */
export const guestGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const target = authenticatedTarget(router, route.queryParamMap.get('redirect'));

  if (auth.isTokenValid()) {
    return target;
  }

  return auth.refreshSession().pipe(
    map((refreshed) => refreshed ? target : true),
    catchError(() => of(true)),
  );
};

/**
 * Ne permet qu'une redirection interne. Cela évite les redirections ouvertes
 * tout en restaurant fidèlement l'écran demandé après un renouvellement de session.
 */
function authenticatedTarget(router: Router, redirect: string | null): UrlTree {
  if (
    !redirect
    || !redirect.startsWith('/')
    || redirect.startsWith('//')
    || redirect.startsWith('/connexion')
  ) {
    return router.createUrlTree(['/tableau-de-bord']);
  }

  return router.parseUrl(redirect);
}
